import { combineReducers, configureStore } from "@reduxjs/toolkit";
import persistReducer from "redux-persist/es/persistReducer";
import persistStore from "redux-persist/es/persistStore";
import storage from "redux-persist/lib/storage"; // uses localStorage by default
import { AuthReducer } from "./reducers/AuthReducer";
import { authApi } from "./services/AuthService";
import { userApi } from "./services/admin/UserService";
import { sideMenuReducer } from "./slices/sidebar";
import { roleApi } from "./services/admin/RoleService";
import { slotPriceApi } from "./services/admin/SlotPriceService";
import { preferenceApi } from "./services/student/PreferenceService";
import { paymentApi } from "./services/student/PaymentService";
import { tutorApi } from "./services/student/TutorService";
import { studentProfileApi } from "./services/student/ProfileService";
import { tutorDetailsApi } from "./services/tutor/DetailsService";
import { tutorPreferenceApi } from "./services/tutor/PreferenceService";
import { tutorAvailabilityApi } from "./services/tutor/AvailabilityService";
import { sessionApi } from "./services/student/SessionService";
import { notificationApi } from "./services/NotificationService";
import { tutorSessionApi } from "./services/tutor/SessionService";

const authPersistConfig = {
  key: "auth",
  storage,
};

const rootReducer = combineReducers({
  sideMenu: sideMenuReducer,
  auth: persistReducer(authPersistConfig, AuthReducer),
  [authApi.reducerPath]: authApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [roleApi.reducerPath]: roleApi.reducer,
  [slotPriceApi.reducerPath]: slotPriceApi.reducer,
  [preferenceApi.reducerPath]: preferenceApi.reducer,
  [paymentApi.reducerPath]: paymentApi.reducer,
  [tutorApi.reducerPath]: tutorApi.reducer,
  [studentProfileApi.reducerPath]: studentProfileApi.reducer,
  [tutorDetailsApi.reducerPath]: tutorDetailsApi.reducer,
  [tutorPreferenceApi.reducerPath]: tutorPreferenceApi.reducer,
  [tutorAvailabilityApi.reducerPath]: tutorAvailabilityApi.reducer,
  [sessionApi.reducerPath]: sessionApi.reducer,
  [notificationApi.reducerPath]: notificationApi.reducer,
  [tutorSessionApi.reducerPath]: tutorSessionApi.reducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }).concat(
        authApi.middleware, 
        userApi.middleware, 
        roleApi.middleware, 
        slotPriceApi.middleware, 
        preferenceApi.middleware,
        paymentApi.middleware,
        tutorApi.middleware,
        studentProfileApi.middleware,
        tutorDetailsApi.middleware,
        tutorPreferenceApi.middleware,
        tutorAvailabilityApi.middleware,
        sessionApi.middleware,
        tutorSessionApi.middleware,
        notificationApi.middleware
      ),
});

export const persistor = persistStore(store);
